/**
 * Fuel Calculator settings shim — the legacy hook now delegates to
 * `taxPricing.js` which is the single source of truth. Kept as a thin
 * facade so older imports continue to compile until they are migrated.
 */
import { useTaxPricing, invalidateTaxPricing, fmtFuel as fmt } from "@/lib/taxPricing";

export function useFuelCalculatorSettings() {
  const tp = useTaxPricing();
  return {
    hst_rate: tp.hst_rate,
    carbon_tax_adjustment: (tp.ontario_road_tax + (tp.carbon_tax_enabled ? tp.federal_carbon_tax : 0)),
    decimal_precision: tp.decimal_precision,
  };
}

export const invalidateFuelCalculatorSettings = invalidateTaxPricing;
export const fmtFuel = fmt;
